import { Box, IconButton, Typography, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { tokens } from "../theme";

const AiBanner = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <Box
      className="printNot"
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      gap="10px"
      p="8px 12px"
      mb="10px"
      width="100%"
      maxWidth="900px"
      borderRadius="4px"
      backgroundColor={colors.greenAccent[700]}
    >
      <AutoAwesomeIcon sx={{ color: "white" }} />
      <Typography
        sx={{ color: "white", fontWeight: 600, flexGrow: 1, cursor: "pointer" }}
        onClick={() => navigate("/migrateToAI")}
      >
        Introducing the new LoanTabs AI.{" "}
        <Typography
          component="span"
          sx={{ color: "white", fontWeight: 600, textDecoration: "underline" }}
        >
          Learn how to move your data over
        </Typography>
      </Typography>
      <IconButton
        size="small"
        aria-label="Dismiss banner"
        onClick={() => setVisible(false)}
      >
        <CloseIcon sx={{ color: "white" }} />
      </IconButton>
    </Box>
  );
};

export default AiBanner;
